import { useAppDispatch, useAppSelector } from '../../../state/state';
import { selectActiveRole, selectAvailableRoles } from '../../../state/UserStatesV2/userSliceV2';
import { openModal } from '../../../state/ModalSlice/ModalSlice';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

export const NavHeader = () => {
  const dispatch = useAppDispatch();
  
  const activeRole = useAppSelector(selectActiveRole);
  const availableRoles = useAppSelector(selectAvailableRoles);

  const handleRoleSwitch = () => {
    dispatch(openModal("RoleSwitchModalOpen"));
  };

  if (!activeRole && !availableRoles.length) {
    return null;
  }

  return (
    <div className="p-3">
      <div 
        className="flex items-center gap-3 px-4 py-1 rounded-lg
                   bg-gradient-to-r from-white to-blue-50/30
                   shadow-[0_4px_10px_rgb(0,0,0,0.12)]
                   hover:shadow-[0_4px_10px_rgb(59,130,246,0.15)]
                    border-gray-300 border-[1px]
                   transform hover:-translate-y-[1px]
                   transition-all duration-300 ease-in-out
                   cursor-pointer group"
        onClick={handleRoleSwitch}
      >
        <div className="flex flex-col">
          <p className="font-semibold uppercase text-blue-900/90 tracking-wide text-sm
                      group-hover:text-blue-800">
            {activeRole ? activeRole.role : 'Owner'}
          </p>
          <p className="text-xs text-blue-600/70 ">
            {activeRole ? activeRole.businessName : 'Your Account'}
          </p>
        </div>
        <div className="ml-auto bg-blue-50 p-1.5 rounded-full
                      group-hover:bg-blue-100 transition-colors duration-300">
          <SwapHorizIcon sx={{ 
            fontSize: 20, 
            color: '#3B82F6',
            transition: 'transform 0.3s ease-in-out',
            '&:hover': { transform: 'rotate(180deg)' }
          }} />
        </div>
      </div>
    </div>
  );
};

export default NavHeader; 